<!--分账-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">收款人管理</span>
      </div>
      <div class="right">
        <Button type="error" @click="toGuide" shape="circle"
          style="margin-left: 10px;font-size: 15px;font-weight: bold;">新分账设置指南</Button>
      </div>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right:10px;" />
      <div>
        <div>
          1、收款人创建后必须点击“收款配置”实名认证，也可将“收款人账号”和初始密码123456发给收款人自行操作实名认证，收款人后台可进行银行账户绑定、资金提现等操作，请谨慎管理收款人账号；
        </div>
        <div>
          2、收款方式绑定成功后，需要在设备列表中，点击“分账”按钮，将收款人与设备关联，并指定分账收益比例;
        </div>
        <div>
          3、已关联收款人的设备，将在每天凌晨2点，将此设备所有应分账的订单自动进行分账（按订单到账金额扣除交易手续费后进行分账，每笔订单最低收取0.01元手续费，不足按最低金额收取，订单到账金额为0不收取），微信和支付宝付款方式的订单按每笔订单进行分账，钱包付款的订单累计1元后再分账;
        </div>
        <div>
          4、收款人禁用：未绑定设备的收款人才能禁用，禁用后无法登录收款人后台；收款人注销：如需注销收款人并将账户余额全部提现，需满足收款人未关联设备达15天以上，或关联的设备15天以上未产生交易记录；
        </div>
      </div>
    </div>
    <div class="content-header">
      <div class="left">
        <!-- <span class="subtitle">收款方式:</span>
        <Select v-model="page_type" placeholder="收款方式" style="width: 115px; margin: 0 5px" @on-change="getData(1)">
          <Option value="0">全部</Option>
          <Option value="open_id">微信</Option>
          <Option value="user_id">支付宝</Option>
          <Option value="open_id,user_id">未绑定</Option>
            </Select> -->
        <Input v-model="page.value" placeholder="根据条件搜索" @on-enter="getData(1)" style="width: 350px">
        <Select v-model="page.cond" slot="prepend" style="width: 150px">
          <Option value="id">收款人ID</Option>
          <Option value="uuid">uuid</Option>
          <Option value="email">收款人账号</Option>
          <Option value="name">收款人</Option>
          <Option value="agent_name" v-if="!agent.tp">合作伙伴</Option>
        </Select>
        <Button slot="append" icon="ios-search" @click="getData(1)"></Button>
        </Input>
        <Button @click="resetParams" style="margin-left: 5px">重置</Button>
      </div>
      <div class="right">
        <Poptip title="导出Excel" placement="left" trigger="hover">
          <Button style="margin: 0 5px 1px 0">导出Excel</Button>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)">导出当前页</Button>
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
        <Button v-if="agent.tp" type="primary" @click="jumpBind" style="margin: 0 10px;">批量绑定</Button>
        <Button type="primary" @click="showAddPayeeModal">新增收款人</Button>
      </div>
    </div>
    <div>
      <Table :columns="columns" :data="data" />
      <div class="t-right">
        <Page @on-change="pageChange" @on-page-size-change="sizeChange" :current="page.p + 1" :total="total"
          show-elevator show-sizer show-total />
      </div>
    </div>
    <Modal v-model="visible" :title="current.id ? '修改收款人' : '新增收款人'" width="600">
      <Form ref="forms" :model="current" :rules="rule" :label-width="130" class="form">
        <FormItem label="收款人:" prop="name">
          <Input v-model="current.name" placeholder="收款人名称" style="width: 300px" :disabled="current.is_del" />
        </FormItem>
        <FormItem label="收款人邮箱/账号:" prop="email">
          <!-- :disabled="current.id" -->
          <Input v-model="current.email" placeholder="收款人邮箱（同时用于收款人账号）" style="width: 300px"
            :disabled="current.is_del" />
          <div class="describe">邮箱用于收款人资金后台账号和账单收件箱，</div>
          <div class="describe">不能重复，请正确填写</div>
        </FormItem>
        <FormItem label="账户类型:" prop="type">
          <RadioGroup v-model="current.type">
            <Radio :label="3" :disabled="current.id">个人</Radio>
            <Radio :label="2" :disabled="current.id">企业</Radio>
          </RadioGroup>
          <Button type="text" style="color: #4788F7;margin-left: 10px;" @click="typeModal.visible = true">查看区别</Button>
          <!-- <div class="describe">保存后不支持修改账户类型</div> -->
        </FormItem>
        <FormItem label="合作伙伴:" prop="agent_id" v-if="!agent.tp">
          <Select v-model="current.agent_id" v-if="!agent.tp && !current.id" style="width: 300px" filterable
            placeholder="合作伙伴">
            <Option v-for="(item, index) in agents" :key="index" :value="item.id">{{ item.agent_name }}</Option>
          </Select>
          <Input disabled v-model="current.agent_name" v-else style="width: 300px" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="visible = false">取消</Button>
        <Button type="error" v-if="!agent.tp && current.id" @click="deleteAccount(current.status)">{{ current.status < 2
          ? '禁用' : '解除禁用' }}</Button>
            <Button type="primary" v-preventReClick @click="modalClick" :loading="accountLoading"
              v-if="current.status != 2">确定</Button>
      </div>
    </Modal>
    <Modal v-model="aliVisible" title="支付宝收款绑定" :width="700" footer-hide>
      <div style="font-size:15px;line-height:28px;color:#000;margin: 0 20px;">
        点击“复制地址”按钮，在电脑浏览器中打开，使用收款人的支付宝账号成功登录后，完成绑定!
        <span style="font-size: 13px;">（支持绑定企业或个人支付宝账号，如需修改绑定的账号，请执行相同操作）</span>
      </div>
      <div class="btn_copy" @click="aliCopy()">复制地址</div>
      <div class="btn_cancel" @click="bindOver">完成绑定后，点击刷新</div>
    </Modal>
    <Modal v-model="qrVisible" title="微信收款绑定" :width="600" footer-hide>
      <!-- <div class="tips">
        微信扫码完成绑定后，请手动关闭此窗口，并刷新页面后查看绑定结果！
                                                  </div> -->
      <div style="color:#4788F7;font-size:16px;margin:15px 0;text-align:center;">
        收款人打开微信扫一扫
      </div>
      <div style="text-align: center;margin-top:20px">
        <canvas :style="{ height: '260px', width: '260px' }" :height="260" :width="260" ref="qr"></canvas>
      </div>
      <div style="text-align:center;margin:20px auto;">
        <Button type="primary" @click="bindOver">完成绑定后，点击刷新</Button>
      </div>

      <!-- <div slot="footer">
        <Button @click="qrVisible = false">取消</Button>
        <Button @click="qrDowload" type="primary">下载</Button>
                                                  </div> -->
    </Modal>

    <Modal v-model="bindModal.visible" title="收款配置" :width="980" footer-hide>
      <div style="text-align: center;font-size: 20px;font-weight: bold;color: #000;">请必须配置下列两项</div>
      <div class="bindModalBox">
        <div class="item" @click="tonglianConfig">
          <p class="title">收款配置一
            <span class="red" :class="{ gray: bindModal.data.status == 1 }">（{{ bindModal.data.status == 1 ? '已配置' :
              '未配置'
              }}）</span>
          <div style="font-size: 12px;margin-left: 190px;" v-if="bindModal.data.status == 0">如已配置，请等待2分钟刷新查看结果</div>
          </p>

          <div class="imgBox">
            <img src="../../assets/images/ic_tonglian.png" alt="" class="icon" />
          </div>
          <div class="des">用户通过微信和支付宝扫码付款的订单费用,配置后可直接提现到对公或个人银行账户</div>
        </div>
        <div class="item" @click="bindAliPay">
          <p class="title">收款配置二
            <span class="red" :class="{ gray: bindModal.data.user_id }">（{{ bindModal.data.user_id ? '已配置' : '未配置'
              }}）</span>
          </p>
          <div class="imgBox">
            <img src="../../assets/images/alipay.png" alt="" class="icon" />
          </div>
          <div class="des">用户通过会员钱包支付的订单费用，配置后可直接分账至您的个人或企业支付宝账户</div>
        </div>
      </div>
    </Modal>
    <Modal v-model="typeModal.visible" title="说明" :width="800" footer-hide>
      <div class="account-type-box">
        <div class="title" style="text-align: center;margin-top: 0;font-size: 18px;">如何选择账户类型</div>
        <div class="title">个人</div>
        <div class="content">指收款方为自然人，通过本人身份证即可完成实名认证，每个收款人最多可绑定5张与实名认证相符的个人银行卡账户，进行后期的资金提现操作；</div>
        <div class="title">企业</div>
        <div class="content">指收款方为企业或个体工商户，通过三证合一后的营业执照+法人身份证即可完成实名认证，每个收款人可绑定与实名认证相符的企业对公银行账户<span
            style="font-weight: bold;">（必须绑定）</span>，和最多1张与实名认证相符的企业法人个人银行卡账户，进行后期的资金提现操作；</div>
        <div class="title">账户实名认证后不支持账户类型和实名认证信息的修改，如有变动可额外新建收款人</div>
        <div style="text-align: center;margin: 50px 0 30px;">
          <sapn
            style="font-size: 15px;background-color: #19be6b;border-radius: 5px;padding: 10px 40px;color: #fff;text-align: center;cursor: pointer;"
            @click="typeModal.visible = false">知道了</sapn>
        </div>
      </div>
    </Modal>
    <Modal v-model="taxModalVisible" :title="null" :width="700" :closable="false" footer-hide>
      <div style="padding: 40px 60px;text-align: left;font-size: 16px;line-height: 1.8;color: #000;">
        <p style="text-align: center;font-size: 22px;font-weight: bold;margin-bottom: 30px;">
          关于费用收取税务合规的公告
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;根据《中华人民共和国个人所得税法》的规定，对个人单月连续收入超800元须申报缴纳个人所得税。
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为遵守国家税法的相关规定，公司特此告知全体合作伙伴，如果收款人关联的设备合计收益超过800元/月，在新增收款人时，选择企业类型收款人，以个体经营户或企业的主体身份与我公司合作，进行分帐收款。
        </p>
        <div style="text-align: center;margin-top: 50px;">
          <Button
            type="primary"
            size="large"
            style="width: 200px;height: 44px;font-size: 16px;"
            @click="handleTaxKnow"
          >
            知道了
          </Button>
        </div>
      </div>
    </Modal>
    <Modal v-model="balanceModal.visible" title="余额" :width="400" :closable="false">
      <div style="margin: 20px 0;">当前账户余额：{{ balanceModal.money }}元
        <span style="color: #4788F7;cursor: pointer;margin-left: 10px;" @click="goWhithdraw"
          v-if="agent.tp === 1">去提现</span>
        <span style="color: #4788F7;cursor: pointer;margin-left: 10px;" @click="WhithdrawAll"
          v-if="agent.tp === 0">全部提现</span>
      </div>
      <div slot="footer">
        <Button type="primary" @click="balanceModal.visible = false">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import excel from '@/libs/excel'
import config from '@/config'
import qr from 'qr.js'
export default {
  data () {
    return {
      data: [],
      columns: [
        { key: 'id', minWidth: 90, title: '收款人ID' },
        { key: 'agent_name', title: '合作伙伴', minWidth: 200 },
        { key: 'name', title: '收款人名称', minWidth: 120 },
        {
          key: 'email',
          title: '收款人账号',
          minWidth: 180,
          render: (h, data) => {
            return h(
              'span',
              data.row.email
            )
          }
        },

        {
          key: 'type',
          title: '类型',
          minWidth: 90,
          render: (h, data) => {
            return h('span', data.row.type == 3 ? '个人' : '企业')
          }
        },
        {
          key: 'money',
          title: '账户余额',
          minWidth: 140,
          render: (h, data) => {
            return [h(
              'span',
              {
                style: {
                  padding: '2px 3px',
                  cursor: 'pointer',
                  color: '#2d8cf0'
                },
                on: {
                  click: () => {
                    // 查询余额
                    if (data.row.status != 1 || !data.row.user_id) {
                      this.$Message.error({
                        content: `请先进行收款配置!`,
                        duration: 2
                      })
                      return
                    }
                    this.GetBalance({ id: data.row.pay_uid }).then(res => {
                      this.balanceModal.visible = true
                      this.balanceModal.id = data.row.pay_uid
                      this.balanceModal.money = parseFloat(res.data.allAmount) / 100
                    })
                  }
                }
              },
              '查看'
            ),
            h(
              'span',
              {
                style: {
                  padding: '2px 3px',
                  marginLeft: '15px',
                  cursor: 'pointer',
                  color: '#2d8cf0'
                },
                on: {
                  click: () => {
                    // 查询余额
                    this.goWhithdraw()
                  }
                }
              },
              '去提现'
            )
            ]
          }
        },
        {
          key: 'config_status',
          title: '配置状态',
          minWidth: 110,
          render: (h, data) => {
            let name = '',
              color = ''
            if (data.row.user_id && data.row.status == 1) {
              name = '完成配置'
              color = '#19be6b'
            } else if (data.row.status == 2) {
              name = '已禁用'
              color = 'red'
            } else if (data.row.status == 3) {
              name = '已注销'
              color = 'red'
            } else {
              name = '未配置'
              color = '#ff9900'
            }
            return h('span', { style: { color: color } }, name)
          }
        },
        { key: 'tel', title: '手机号', minWidth: 120 },
        {
          key: 'uuid',
          title: 'uuid',
          minWidth: 180,
          render: (h, data) => {
            return h(
              'span',
              data.row.uuid
            )
          }
        },
        {
          key: 'create_time',
          title: '创建时间',
          minWidth: 150,
          render: (h, data) => {
            return h(
              'span',
              data.row.create_time ? this.$moment(data.row.create_time) : '-'
            )
          }
        }
      ],

      current: {
        type: 0,
        agent_id: 0,
        name: '',
        phone: '',
        email: '',
        pay_id: 0,
        user_id: '',
        is_del: -1,
        bind_time: ''
      },
      rule: {
        name: [{ required: true, message: '请填写收款人', trigger: 'blur' }],
        email: [
          {
            validator: (rule, value, callback) => {
              var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
              if (filter.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确的邮箱地址'))
              }
            },
            required: true,
            message: '请填写收款人邮箱',
            trigger: 'blur'
          }
        ],
        agent_id: [
          {
            required: true,
            validator: (rule, value, callback) => {
              console.log(rule, value)
              if (!this.agent.tp && !value) {
                callback(new Error('请选择合作伙伴'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      agents: [],
      agent_id: 0,
      visible: false,

      page: {
        p: 0,
        l: 10,
        value: '',
        cond: 'id'
      },
      page_type: '0',
      page_bind_time: '',
      total: 0,

      aliVisible: false,
      qrVisible: false,
      filename: '',
      payMode: {
        visible: false,
        data: {
          id: 0
        }
      },
      bindModal: {
        visible: false,
        data: {
          id: 0
        }
      },
      allAccount: [], // 所有收款人
      typeModal: {
        visible: false
      },
      taxModalVisible: false,
      accountLoading: false,
      outTime: 10 * 1000, // 超时时间10s
      balanceModal: {
        visible: false,
        money: 0,
        id: 0
      }
    }
  },
  mounted () {
    this.columns.push(
      {
        key: 'operator',
        title: '操作',
        export_ignore: true,
        minWidth: 280,
        fixed: 'right',
        align: 'right',
        render: (h, data) => {
          let temp = []
          if (data.row.status < 3) {
            temp.push(
              h(
                'Button',
                {
                  props: { size: 'small', type: 'success' },
                  style: { marginRight: '5px' },
                  on: {
                    click: () => {
                      if (data.row.status == 2) {
                        this.$Message.warning('该收款人已被禁用')
                        return
                      }
                      this.bindModal.visible = true
                      this.bindModal.data = data.row
                    }
                  }
                },
                '收款配置'
              )
            )
          }
          temp = temp.concat([

            h(
              'Button',
              {
                props: { size: 'small', type: 'info' },
                style: { marginRight: '5px' },
                on: {
                  click: () => {
                    if (data.row.status == 2) {
                      this.$Message.warning('该收款人已被禁用')
                      return
                    }
                    this.$Modal.confirm({
                      title: '重置密码',
                      content: `<p>是否重置${data.row.name}密码为: 123456</p>`,
                      onOk: () => {
                        this.InitUserPWD({ id: data.row.pay_uid }).then((res) => {
                          if (res.status) {
                            this.$Message.success('重置成功')
                          } else {
                            this.$Message.error(res.msg)
                          }
                        })
                      }
                    })
                  }
                }
              },
              '重置密码'
            ),
            h(
              'Button',
              {
                props: { size: 'small', type: 'warning' },
                style: { marginRight: '5px' },
                on: {
                  click: () => {
                    this.visible = true
                    this.current = data.row
                  }
                }
              },
              '编辑'
            )
          ])

          /* if(data.row.status === 1){
            temp.push(
              h(
                "Button",
                {
                  props: { size: "small", type: "error" },
                  style: { marginRight: "5px" },
                  on: {
                    click: () => {
                      if (data.row.status == 2) {
                        this.$Message.warning('该收款人已被禁用');
                        return;
                      }
                      if (data.row.status == 3) {
                        this.$Message.warning('该收款人已被注销');
                        return;
                      }

                      this.$Modal.confirm({
                        title: "重要提醒",
                        content: `<p>是否确认注销当前收款人，注销后请于15个自然日后登录收款人后台提取剩余资金</p>`,
                        onOk: () => {
                          this.logiutAccount(data.row.id)
                        },
                      });
                    }
                  }
                },
                "注销"
              )
            )
          } */
          return h(
            'span',
            {},
            temp
          )
        }
      }
    )
    this.getData().then(res => {
      this.data = res.data
      this.total = res.total
    })
  },
  methods: {
    aliCopy (id) {
      let oInput = document.createElement('input')
      oInput.value = `https://openauth.alipay.com/oauth2/publicAppAuthorize.htm?app_id=${config.ali.app_id
      }&scope=auth_user&redirect_uri=https%3A%2F%2Fwww.aidprint.com%2Fprint%2Fpayment%2Fuser%2Fali%2Fuser_id&state=${this.aliId
      }`
      console.log('oInput.value', oInput.value)
      document.body.appendChild(oInput)
      oInput.select()
      document.execCommand('Copy')
      oInput.style.display = 'none'
      document.body.removeChild(oInput)

      this.$Message.success('复制成功!')
    },
    exportData (is_all) {
      let params = {
        title: [],
        key: [],
        autoWidth: true,
        filename: '收款人管理列表'
      }
      this.columns.map(item => {
        if (item.export_ignore) {
          return
        }
        if (item.key === 'money') {
          return
        }
        params.title.push(item.title)
        params.key.push(item.key)
      })
      if (is_all) {
        let cond = JSON.parse(JSON.stringify(this.page))
        cond.l = 10000
        cond.p = 0
        console.log('cond', cond)
        this.GetPayee(cond).then(res => {
          params.data = this.formatExportData(res.data)
          excel.export_array_to_excel(params)
        })
      } else {
        params.data = this.formatExportData(this.data)
        excel.export_array_to_excel(params)
      }
    },
    formatExportData (data) {
      data.map(item => {
        item.uuid = item.uuid
        if (item.user_id) {
          item.code = item.user_id
        } else if (item.open_id) {
          item.code = item.open_id
        } else {
          item.code = ''
        }
        if (item.type === 2) {
          item.type = '企业'
        } else if (item.type === 3) {
          item.type = '个人'
        }

        if (item.user_id && item.status == 1) {
          item.config_status = '完成配置'
        } else if (item.status == 2) {
          item.config_status = '已禁用'
        } else if (item.status == 3) {
          item.config_status = '已注销'
        } else {
          item.config_status = '未配置'
        }

        item.bind_time = this.$moment(item.bind_time)
      })
      return data
    },
    qrDowload () {
      let imgData = this.$refs.qr.toDataURL('png')
      imgData = imgData.replace(() => {
        var type = 'png'.toLowerCase().replace(/jpg/i, 'jpeg')
        var r = type.match(/png|jpeg|bmp|gif/)[0]
        return 'image/' + r
      }, 'image/octet-stream')

      var save_link = document.createElementNS(
        'http://www.w3.org/1999/xhtml',
        'a'
      )
      save_link.href = imgData
      save_link.download = this.filename
      var event = document.createEvent('MouseEvents')
      event.initMouseEvent(
        'click',
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      )
      save_link.dispatchEvent(event)
    },

    getBackingStorePixelRatio (ctx) {
      return (
        ctx.webkitBackingStorePixelRatio ||
        ctx.mozBackingStorePixelRatio ||
        ctx.msBackingStorePixelRatio ||
        ctx.oBackingStorePixelRatio ||
        ctx.backingStorePixelRatio ||
        1
      )
    },
    getData (filter) {
      if (filter) {
        this.page.p = 0
      }
      if (this.page_type !== '0') {
        this.page.type = this.page_type
      }
      this.GetPayee(this.page).then(res => {
        this.data = res.data
        this.total = res.total
      })
    },
    showAddPayeeModal () {
      this.taxModalVisible = true
    },
    handleTaxKnow () {
      this.taxModalVisible = false
      this.openModal()
    },
    openModal (data) {
      this.current = {
        type: 3,
        agent_id: 0,
        name: '',
        pay_uid: 0,
        user_id: '',
        phone: ''
      }
      // 运营商
      if (!this.agent.tp) {
        this.getAgentList({
          l: 1000,
          cond: 'id',
          value: '',
          is_del: 0,
          senior: '',
          key: 'id',
          order: 'desc'
        }).then(res => {
          this.agents = res.data
        })
      }
      this.visible = true
      this.GetPayee({ p: 0, l: 10000 }).then(res => {
        this.allAccount = res.data
      })
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    modalClick () {
      // 防抖：如果正在提交中，直接返回
      if (this.accountLoading) {
        return
      }

      this.$refs.forms.validate(valid => {
        if (valid) {
          this.accountLoading = true
          let temp = JSON.parse(JSON.stringify(this.current))
          delete temp._rowKey
          delete temp._index
          delete temp.agent_name
          temp.name = temp.name.trim()
          temp.email = temp.email.trim()
          this.AddPayee(temp).then(res => {
            this.accountLoading = false
            this.getData()
            if (res.status) {
              this.visible = false
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(err => {
            // 捕获错误，确保 loading 状态被重置
            this.accountLoading = false
            this.$Message.error('操作失败，请重试')
          })
          // 设置网络超时显示
          setTimeout(() => {
            if (this.accountLoading) {
              this.$Message.error('网络超时，请重新操作!')
              this.accountLoading = false
            }
          }, this.outTime)
        } else {
          console.log('验证失败')
        }
      })
    },
    resetParams () {
      this.page = {
        p: 0,
        l: 10,
        value: '',
        cond: 'id'
      }
      this.page_type = '0'
      this.getData()
    },

    setPayMode (row) {
      this.payMode.visible = false
      this.bindModal = {
        visible: true,
        data: row || this.payMode.data
      }
    },

    bindAliPay () {
      console.log('this.bindModal', this.bindModal)
      this.bindModal.visible = false
      this.aliVisible = true
      this.aliId = this.bindModal.data.id
    },

    bindOver () {
      this.payMode = {
        visible: false,
        data: { id: 0 }
      }
      this.bindModal = {
        visible: false,
        data: { id: 0 }
      }
      this.qrVisible = false
      this.aliVisible = false
      this.getData()
    },
    tonglianConfig () {
      this.bindModal.visible = false
      window.open(config.payment, '_blank')
    },
    goWhithdraw () {
      window.open(config.payment, '_blank')
    },
    // 禁用收款人
    deleteAccount (status) {
      // this.$Modal.confirm({
      //   title: "重要提示",
      //   content: `收款人删除后，该邮箱“${this.current.email}”将不能用于创建新的收款人，确认删除吗？`,
      //   onOk: () => {

      //   }
      // });
      this.AddPayee({
        id: this.current.id,
        pay_uid: this.current.pay_uid,
        status: status == 2 ? 1 : 2,
        dis: 1

      }).then(res => {
        if (res) {
          if (res.status) {
            this.visible = false
            this.getData()
            this.$Message.success('操作成功!')
          } else {
            this.$Message.error(res.msg)
          }
        } else {
          this.$Notice.warning({
            title: '重要提示',
            desc:
              '该收款人已和设备绑定，请至设备列表中点击设备档案后方的“分账”按钮，移除收款人后再操作！',
            duration: 8
          })
        }
      })
    },
    jumpBind () {
      this.$router.push({ path: 'payment/bind' })
    },
    toGuide () {
      const routerUrl = this.$router.resolve({ path: 'payment/guide' })
      window.open(routerUrl.href, '_blank')
    },
    // 注销收款人
    logiutAccount (id) {
      this.LogoutAccount({ id }).then(res => {
        this.$Message[res.status ? 'success' : 'error'](res.msg)
        if (res.status) {
          this.getData()
        }
      })
    },
    WhithdrawAll () {
      this.$Modal.confirm({
        title: '重要提示',
        content: '你正在操作余额全部提现，请确保在代理商提出申请15天后操作，否则可能造成余额不足退款失败！',
        okText: '确认提现',
        cancelText: '取消',
        onOk: () => {
          this.WithdrawalOk()
        }
      })
    },
    WithdrawalOk () {
      const data = { id: this.balanceModal.id, Amount: this.balanceModal.money }
      console.log('data', data)
      this.$Spin.show()
      this.Withdrawal(data).then(res => {
        this.$Spin.hide()

        this.$Message[res.status ? 'success' : 'error'](res.msg)
      })
    },
    ...mapActions([
      'getAgentList',
      'AddPayee',
      'GetPayee',
      'SendTelCode',
      'CodeCheck',
      'GetBalance',
      'InitUserPWD',
      'LogoutAccount',
      'Withdrawal'
    ])
  },
  computed: mapGetters({
    agent: 'agent',
    access: 'access'
  })
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
